var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive && _vm.component)?_c('div',{staticClass:"sub-menu"},[_c(_vm.getComponent(),{tag:"component",attrs:{"parentData":{ equipment: _vm.item, attr: _vm.attr }},on:{"update-field":_vm.updateField}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }